import { Injectable } from "@angular/core";
@Injectable()
export class NewsTransFormer {
    transform(news) {
        return {
            title: news.Title,
            image: news.Image,
            link: news.Link,
            viewCount: news.Views
        };
    }
}
